import { GetFormalOffersResponse } from '@iwoca/lapi-client/edge';

export const getFormalOfferIds = (
    formalOffersResponse: GetFormalOffersResponse
): string[] => {
    const offerIds: string[] = [];
    if (formalOffersResponse.data) {
        if (
            formalOffersResponse.data!.formal_offers &&
            formalOffersResponse.data!.formal_offers.length > 0
        ) {
            formalOffersResponse!.data!.formal_offers.forEach(
                (formal_offer) => {
                    offerIds.push(formal_offer.offer_id!);
                }
            );
        }
    }
    return offerIds;
};
